import { RoutesApp } from '@components/RoutesApp'

function AppRoutes(): JSX.Element {
  return <RoutesApp />
}

export default AppRoutes
